module.exports = __webpack_public_path__ + "static/img/platnew.767c1fe8.png";